/* Little Omo: connects the designed basket and "Add to bag" buttons to the real Shopify cart. */
(function () {
  // design name -> product handle in the Little Omo store
  var ALIAS = {
    'alphabet wall print poster': 'abc-numbers-poster', 'numbers wall print poster': 'alphabet-poster-copy',
    'puzzle & flashcard gift set': 'puzzle-flashcard-set', 'flashcard gift set': 'flashcard-set-1',
    'little omo wrap': 'wrapping-paper', 'gift boxes': 'small-gift-box', 'e-gift card': 'e-gift-card',
    'head coverings wall print poster': 'head-coverings-wall-print-poster', 'afro hairstyles wall print poster': 'afro-hairstyles-wall-print-poster',
    'head coverings wall print': 'head-coverings-wall-print-poster',
    'afro hairstyles wall print': 'afro-hairstyles-wall-print-poster',
    'alphabet wall print': 'abc-numbers-poster', 'alphabet poster': 'abc-numbers-poster',
    'numbers wall print': 'alphabet-poster-copy', 'numbers poster': 'alphabet-poster-copy',
    'numbers flashcards': 'numbers-flashcard-set', 'numbers 1-20 flashcards': 'numbers-flashcard-set', 'numbers 1–20 flashcards': 'numbers-flashcard-set', 'numbers 1–20 and maths symbols flashcards': 'numbers-flashcard-set',
    'face puzzle': 'face-puzzles', 'one face puzzle': 'face-puzzles',
    'adventure park jigsaw puzzle': 'adventure-park-puzzle',
    'fruit puzzle': 'wholefood-puzzles', 'veg puzzle': 'wholefood-puzzles',
    'little omo gift wrap': 'wrapping-paper', 'happy birthday card': 'happy-birthday'
  };
  // bundles that are not products yet: add the sets inside them
  var FLASH = ['alphabet-flashcards', 'numbers-flashcard-set', 'parts-of-the-body-flashcards', 'head-coverings-flashcards', 'afro-hairstyles-memory-game'];
  var BUNDLES = {
    'first words starter set': ['alphabet-flashcards', 'numbers-flashcard-set', 'parts-of-the-body-flashcards'],
    'celebrate every crown': ['head-coverings-flashcards', 'afro-hairstyles-memory-game'],
    'the complete flashcard collection': FLASH, 'complete flashcard collection': FLASH,
    'storytime & play': ['the-four-and-the-golden-door', 'face-puzzles'], 'storytime and play': ['the-four-and-the-golden-door', 'face-puzzles'],
    'ready-to-gift birthday box': ['face-puzzles', 'isaiahs-extraordinary-mum', 'wrapping-paper', 'happy-birthday'],
    'nursery & classroom diversity pack': FLASH.concat(['face-puzzles', 'head-coverings-wall-print-poster', 'afro-hairstyles-wall-print-poster', 'the-four-and-the-golden-door', 'isaiahs-extraordinary-mum']),
    'wholefood puzzles': ['wholefood-puzzles']
  };
  var BUNDLE_PRODUCT = {
    'first words starter set': 'first-words-starter-set',
    'celebrate every crown': 'celebrate-every-crown',
    'celebrate every crown with face puzzle': 'celebrate-every-crown-with-face-puzzle',
    'the complete flashcard collection': 'the-complete-flashcard-collection', 'complete flashcard collection': 'the-complete-flashcard-collection',
    'storytime & play': 'storytime-play', 'storytime and play': 'storytime-play',
    'ready-to-gift birthday box': 'ready-to-gift-birthday-box',
    'nursery & classroom diversity pack': 'nursery-classroom-diversity-pack'
  };
  var GO = { 'posters': '/collections/posters' };
  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function handleFor(name) { var n = norm(name); return ALIAS[n] || slug(n); }
  function variantOf(handle) {
    return fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]; return v.id;
    });
  }
  var LINES = window.LO_CART_LINES || {};
  function slug(s) { return s.toLowerCase().replace(/&/g, 'and').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  function refreshLines() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      LINES = {}; c.items.forEach(function (i) { LINES[i.product_title] = i.key; LINES[i.title] = i.key; });
      document.querySelectorAll('.bag-badge').forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
    }).catch(function () {});
  }
  function findName(btn) {
    var holder = btn.closest('[data-name]');
    if (holder && holder.dataset.name) return holder.dataset.name;
    holder = btn.closest('.product-card, article, figure, .bg-card, .qv-modal, .trio-set, li, .card') || btn.parentElement;
    var el = holder && holder.querySelector('.product-name, .bg-name, .qv-name, h3, h2, .pdp-h1');
    return el ? el.textContent.trim() : null;
  }
  function resolveVariant(btn) {
    var card = btn.closest('[data-variant]');
    if (card && card.dataset.variant) return Promise.resolve(card.dataset.variant);
    if ((btn.classList.contains('pdp-add') || btn.closest('.pdp-buy, .pdp-sticky')) && window.LO_PRODUCT) {
      var sel = document.getElementById('pdpVariant');
      return Promise.resolve(sel ? sel.value : window.LO_PRODUCT.variant);
    }
    var name = findName(btn);
    if (!name) return Promise.resolve(null);
    return variantOf(handleFor(name)).catch(function () { return { search: name }; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bg-add, .trio-add');
    if (!btn || btn.disabled) return;
    var items, props;
    if (btn.classList.contains('trio-add')) {
      var picks = [];
      document.querySelectorAll('.trio-set').forEach(function (t) {
        var q = t.querySelector('.trio-qty b'), n = +(q ? q.textContent : 0);
        var nm = t.dataset.name || (t.querySelector('[class*="name"], h3, h4, p') || {}).textContent || '';
        for (var k = 0; k < n; k++) picks.push(nm.trim());
      });
      items = ['flashcard-trio-bundle']; props = { 'Chosen sets': picks.join(', ') };
    } else {
      var card = btn.closest('article') || btn.parentElement;
      var name = norm((card.querySelector('.bg-name') || {}).textContent);
      if (GO[name]) { location.href = GO[name]; return; }
      var up = card.querySelector('[data-up]');
      var key = (up && up.checked && name === 'celebrate every crown') ? 'celebrate every crown with face puzzle' : name;
      var bh = BUNDLE_PRODUCT[key];
      if (bh) {
        fetch('/products/' + bh + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
          // bundles with a face puzzle need a style picked first
          if (p.variants.length > 1) { location.href = '/products/' + bh; return; }
          return post('/cart/add.js', { items: [{ id: p.variants[0].id, quantity: 1 }] }).then(refreshLines);
        }).catch(function () {
          var parts = (BUNDLES[key] || BUNDLES[name] || []).slice();
          if (key !== name) parts.push('face-puzzles');
          Promise.all(parts.map(function (h) { return variantOf(h).catch(function () { return null; }); })).then(function (ids) {
            var lines = ids.filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
            if (lines.length) post('/cart/add.js', { items: lines }).then(refreshLines);
          });
        });
        return;
      }
      items = (BUNDLES[name] || [handleFor(name)]).slice();
    }
    Promise.all(items.map(function (h) { return variantOf(h).catch(function () { return null; }); })).then(function (ids) {
      var lines = ids.filter(Boolean).map(function (id) { var l = { id: +id, quantity: 1 }; if (props) l.properties = props; return l; });
      if (!lines.length) return;
      return post('/cart/add.js', { items: lines }).then(refreshLines);
    });
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-btn:not(.choose-btn), .pdp-add, .qv-add, [data-add-to-bag]');
    if (!btn || btn.disabled) return;
    resolveVariant(btn).then(function (v) {
      if (v && typeof v === 'object') { location.href = '/search?q=' + encodeURIComponent(v.search); return; }
      if (!v) return;
      var q = btn.classList.contains('pdp-add') && document.getElementById('qtyInput');
      var quantity = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
      var extras = btn.classList.contains('pdp-add') ? Array.prototype.slice.call(document.querySelectorAll('.pdp-gift input[data-gift-handle]:checked')).map(function (i) { return i.dataset.giftHandle; }) : [];
      return Promise.all(extras.map(function (h) { return variantOf(h).catch(function () { return null; }); })).then(function (ids) {
        var items = [{ id: +v, quantity: quantity }].concat(ids.filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; }));
        return post('/cart/add.js', { items: items }).then(refreshLines);
      });
    });
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-less], [data-more], [data-del]');
    if (!t) return;
    var raw = t.dataset.less || t.dataset.more || t.dataset.del, name = decodeURIComponent(raw);
    var key = LINES[name]; if (!key) return;
    var list = []; try { list = JSON.parse(localStorage.getItem('lo_basket')) || []; } catch (x) {}
    var item = list.filter(function (i) { return i.name === name; })[0], qty = item ? item.qty : 1;
    var next = t.dataset.del ? 0 : t.dataset.less ? qty - 1 : qty + 1;
    post('/cart/change.js', { id: key, quantity: Math.max(0, next) }).then(refreshLines);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('#bkGo, .bk-go')) { e.preventDefault(); e.stopImmediatePropagation(); location.href = '/checkout'; }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.id !== 'pdpVariant') return;
    var o = e.target.selectedOptions[0], p = document.getElementById('pdpPrice');
    if (p && o) p.textContent = o.dataset.price;
    if (window.LO_PRODUCT) window.LO_PRODUCT.variant = +e.target.value;
  });
  document.addEventListener('DOMContentLoaded', function () {
    var cards = document.querySelectorAll('#colGrid .product-card');
    document.querySelectorAll('.fopt input[data-group]').forEach(function (inp) {
      var em = inp.parentElement.querySelector('[data-live-count]'); if (!em) return;
      var g = inp.dataset.group, v = inp.value, n = 0;
      cards.forEach(function (c) { var d = g === 'cat' ? c.dataset.cat : g === 'ages' ? c.dataset.ages : c.dataset.band; if ((' ' + (d || '') + ' ').indexOf(' ' + v + ' ') >= 0) n++; });
      em.textContent = n; if (!n) inp.parentElement.style.display = 'none';
    });
  });
})();
